import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Checkbox from "../../Components/checkbox/Checkbox";
import ApiDropdown from "../../Components/DropDown/Apidropdown";
import Input from "../../Components/input/input";
import config from "../../config";
import "../../Style/IncidentAdd.css";
import { useFetchFullName } from "../Incidents/Hooks/useFetchFullName";
import { Problem, initialProblem } from "./Problem";
import TaskGridLookup from "../../Components/Lookup/Lookup";
import { ChangeData } from "../../utils/Change/changeTypes";
import { KnowledgeBaseData } from "../../utils/KnowledgeBase/KnowledgeBaseTypes";
import { RmaData } from "../../utils/Rma/rmaTypes";
import { TaskData } from "../../utils/Task/taskTypes";
import { IncidentData } from "../../utils/Incident/incidentTypes";
import { ProblemData } from "../../utils/Problem/problemTypes";
import { authFetch } from "../../utils/Security/authFetch";
import TextArea from "../../Components/TextArea/TextArea";
import FileUploader from "../../Components/FileUpload/FileUpload";
import { handleEdit } from "../../utils/Problem/problemHandlers";
type Message = {
  id: number;
  username: string;
  message: string;
  date: string;
};
function ProblemEdit() {
  const [problem, setProblem] = useState<Problem>(initialProblem);
  const { id } = useParams();
  const navigate = useNavigate();
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const organization = localStorage.getItem("organization") || undefined;
  const [network, setNetwork] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [site, setSite] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [emails, setEmails] = useState<[]>();
  const [journalMessages, setJournalMessages] = useState<Message[]>([]);

  const [customer, setCustomer] = useState<
    string | number | (string | number)[] | undefined
  >(undefined);
  const [isTaskLookupOpen, setIsTaskLookupOpen] = useState(false);
  const handleOpenTaskLookup = () => setIsTaskLookupOpen(true);
  const handleCloseTaskLookup = () => setIsTaskLookupOpen(false);
  const [selectedTask, setSelectedTask] = useState<
    (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  >([]);
  useEffect(() => {
    if (id) {
      authFetch(`${config.apiBaseUrl}/api/problems/${id}`)
        .then((res) => res.json())
        .then((data) => setProblem(data))
        .catch((err) => console.error("Failed to fetch problem:", err));
    }
  }, [id]);
  useEffect(() => {
    const { urgency, impact } = problem;
    if (!urgency || !impact) return;
    const key = `${urgency}-${impact}`;
    let priority = "";
    if (key === "Critical-Critical") priority = "Critical";
    else if (
      key === "Critical-High" ||
      key === "High-High" ||
      key === "High-Critical"
    )
      priority = "High";
    else if (
      key === "Critical-Medium" ||
      key === "High-Medium" ||
      key === "Medium-High" ||
      key === "Medium-Medium" ||
      key === "Medium-Critical"
    )
      priority = "Medium";
    else if (
      key === "Low-Low" ||
      key === "Low-High" ||
      key === "Low-Medium" ||
      key === "Low-Critical"
    )
      priority = "Low";
    else if (
      key === "Medium-Low" ||
      key === "High-Low" ||
      key === "Critical-Low"
    )
      priority = "Low";
    setProblem((prev) => ({ ...prev, priority }));
  }, [problem.urgency, problem.impact]);
  useEffect(() => {
    setCustomer(problem.affectedCustomer);
  }, [problem.affectedCustomer]);

  useFetchFullName((fullName: string) => {
    setProblem((prev) => ({ ...prev, user: fullName }));
  });
  const handleCancel = () => {
    navigate("/problem", { state: { problem } });
  };
  const handleDataChange = (field: keyof Problem, value: any) => {
    setProblem((prev) => ({ ...prev, [field]: value }));
  };
  const handleTaskSelect = (
    tasks: (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  ) => {
    const ticketIds = tasks.map((t) => t.ticketId);
    handleDataChange("relatedobject", ticketIds);
    setSelectedTask(tasks);
  };
  const mockLoadTasksByIds = async (
    ids: string[]
  ): Promise<
    (
      | TaskData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | IncidentData
    )[]
  > => {
    return ids.map((id) => {
      const baseData = {
        ticketId: id,
        title: `Loaded ${id}`,
      };
      if (id.startsWith("TSK")) {
        return { ...baseData, source: "task" } as unknown as TaskData;
      } else if (id.startsWith("CHN")) {
        return { ...baseData, source: "change" } as unknown as ChangeData;
      } else if (id.startsWith("RMA")) {
        return { ...baseData, source: "rma" } as unknown as RmaData;
      } else if (id.startsWith("PRB")) {
        return { ...baseData, source: "problem" } as unknown as ProblemData;
      } else {
        return { ...baseData, source: "incident" } as unknown as IncidentData;
      }
    });
  };
  useEffect(() => {
    if (id) {
      authFetch(`${config.apiBaseUrl}/api/problems/${id}`)
        .then((res) => res.json())
        .then(async (data) => {
          setProblem(data);

          if (data.relatedobject) {
            const ticketIds = Array.isArray(data.relatedobject)
              ? data.relatedobject
              : data.relatedobject.split(",");
            const tasks = await mockLoadTasksByIds(ticketIds);
            setSelectedTask(tasks);
          }
        })
        .catch((err) => console.error("Failed to fetch incident:", err));
    }
  }, [id]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const updatedProblem: Problem = {
      ...problem,
      affectedSite:
        localStorage.getItem("isAllSite") === "true"
          ? ["All Sites"]
          : problem.affectedSite,
      affectedLink:
        localStorage.getItem("isAllLink") === "true"
          ? ["All Links"]
          : problem.affectedLink,
      affectedNetwork:
        localStorage.getItem("isAllNetwork") === "true"
          ? ["All Networks"]
          : problem.affectedNetwork,
    };
    authFetch(`${config.apiBaseUrl}/api/problems/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedProblem),
    })
      .then((res) => res.json())
      .then(async (data) => {
        const fetchMessages = async () => {
          if (!data?.ticketId) return;
          const res = await authFetch(
            `${config.apiBaseUrl}/api/messages/ticket/${data.ticketId}`
          );
          if (res.ok) setJournalMessages(await res.json());
        };
        await handleEdit(data, navigate, fetchMessages);
        navigate("/problem");
      })
      .catch((err) => console.error("Failed to update problem:", err));
  };

  return (
    <div className="incident-form">
      <form onSubmit={handleSubmit}>
        <section className="form-section">
          <h3>Problem Information</h3>
          <div className="grid">
            <Input
              type="text"
              readOnly
              label="Created By"
              value={problem.createdby || ""}
              onChange={(val) => handleDataChange("createdby", val)}
            />
            <Input
              type="text"
              label="Ticket ID"
              value={problem.ticketId || ""}
              onChange={(val) => handleDataChange("ticketId", val)}
            />

            <Input
              type="datetime-local"
              label="Problem Start Date/Time"
              value={problem.problemStartDatetime || ""}
              onChange={(val) => handleDataChange("problemStartDatetime", val)}
            />
            <Input
              type="datetime-local"
              label="Problem End Date/Time"
              value={problem.problemCloseDatetime || ""}
              onChange={(val) => handleDataChange("problemCloseDatetime", val)}
            />
            <Input
              readOnly
              type="text"
              label="Status"
              value={problem.status || ""}
              onChange={(val) => handleDataChange("acceptanceStatus", val)}
            />
          </div>
        </section>

        <section className="form-section">
          <h3>Customer & Network</h3>
          <div className="grid">
            {!isAdmin && (
              <ApiDropdown
                api="affected-customers"
                labelKey="customername"
                value={organization}
                valueKey="customername"
                label="Customer"
                disabled
                isMulti
                onOpen={async () => {
                  try {
                    const responseIds = await authFetch(
                      `${config.apiBaseUrl}/api/users/id-by-organization?organization=${organization}`
                    );
                    if (!responseIds.ok)
                      throw new Error(
                        `HTTP error! status: ${responseIds.status}`
                      );
                    const userIds = await responseIds.json();

                    const userIdsParam = Array.isArray(userIds)
                      ? userIds.join(",")
                      : userIds;
                    const responseEmails = await authFetch(
                      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                    );
                    if (!responseEmails.ok)
                      throw new Error(
                        `HTTP error! status: ${responseEmails.status}`
                      );
                    const emails = await responseEmails.json();
                    setEmails(emails);

                    handleDataChange("foruserid", userIds);

                    handleDataChange("affectedCustomer", [organization]);
                  } catch (error) {
                    console.error("Failed to fetch customer or emails:", error);
                  }
                }}
              />
            )}
            {isAdmin && (
              <ApiDropdown
                api="affected-customers"
                labelKey="customername"
                valueKey="customername"
                label="Customer"
                value={customer}
                isMulti
                onChange={async (val) => {
                  setCustomer(val);
                  try {
                    const responseIds = await authFetch(
                      `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`
                    );
                    if (!responseIds.ok)
                      throw new Error(
                        `HTTP error! status: ${responseIds.status}`
                      );
                    const userIds = await responseIds.json();

                    const userIdsParam = Array.isArray(userIds)
                      ? userIds.join(",")
                      : userIds;
                    const responseEmails = await authFetch(
                      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`
                    );
                    if (!responseEmails.ok)
                      throw new Error(
                        `HTTP error! status: ${responseEmails.status}`
                      );
                    const emails = await responseEmails.json();
                    setEmails(emails);

                    handleDataChange("foruserid", userIds);
                    handleDataChange("affectedCustomer", val);
                  } catch (error) {
                    console.error("Failed to fetch customer or emails:", error);
                  }
                }}
              />
            )}
            {!isAdmin && organization && (
              <ApiDropdown
                api={`everything/networks?customer=${organization}`}
                labelKey="label"
                valueKey="value"
                label="Networks"
                value={problem.affectedNetwork}
                isMulti
                onChange={(val) => {
                  setNetwork(val);
                  handleDataChange("affectedNetwork", val);
                }}
              />
            )}

            {!isAdmin && organization && (
              <>
                {(network || problem.affectedNetwork) && (
                  <ApiDropdown
                    api={`everything/sites?customer=${organization}&network=${
                      network || problem.affectedNetwork
                    }`}
                    labelKey="label"
                    valueKey="value"
                    label="Site"
                    value={problem.affectedSite}
                    isMulti
                    onChange={(val) => {
                      setSite(val);
                      handleDataChange("affectedSite", val);
                    }}
                  />
                )}

                {(site || problem.affectedSite) && (
                  <ApiDropdown
                    api={`everything/links?customer=${organization}&network=${
                      network || problem.affectedNetwork
                    }&site=${site || problem.affectedSite}`}
                    labelKey="label"
                    valueKey="value"
                    label="Link"
                    value={problem.affectedLink}
                    isMulti
                    onChange={(val) => handleDataChange("affectedLink", val)}
                  />
                )}

                <ApiDropdown
                  api={`everything/asset?customer=${organization}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label="Assets"
                  onChange={(val) => handleDataChange("asset", val)}
                />
              </>
            )}

            {isAdmin && (
              <>
                {(customer || problem.affectedCustomer) && (
                  <ApiDropdown
                    api={`everything/networks?customer=${
                      customer || problem.affectedCustomer
                    }`}
                    labelKey="label"
                    valueKey="value"
                    label="Networks"
                    value={problem.affectedNetwork}
                    isMulti
                    onChange={(val) => {
                      setNetwork(val);
                      handleDataChange("affectedNetwork", val);
                    }}
                  />
                )}

                {(network || problem.affectedNetwork) && (
                  <ApiDropdown
                    api={`everything/sites?customer=${
                      customer || problem.affectedCustomer
                    }&network=${network || problem.affectedNetwork}`}
                    labelKey="label"
                    valueKey="value"
                    value={problem.affectedSite || ""}
                    label="Site"
                    isMulti
                    onChange={(val) => {
                      setSite(val);
                      handleDataChange("affectedSite", val);
                    }}
                  />
                )}

                {(site || problem.affectedSite) && (
                  <ApiDropdown
                    api={`everything/links?customer=${
                      customer || problem.affectedCustomer
                    }&network=${network || problem.affectedNetwork}&site=${
                      site || problem.affectedSite
                    }`}
                    labelKey="label"
                    valueKey="value"
                    label="Link"
                    value={problem.affectedLink}
                    isMulti
                    onChange={(val) => handleDataChange("affectedLink", val)}
                  />
                )}

                <ApiDropdown
                  api={`everything/asset?customer=${customer}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label="Assets"
                  onChange={(val) => handleDataChange("asset", val)}
                />
              </>
            )}
          </div>
        </section>

        <section className="form-section">
          <h3>Problem Severity</h3>
          <div className="grid">
            <ApiDropdown
              api="Urgencys"
              labelKey="name"
              valueKey="name"
              label="Urgency"
              value={problem.urgency}
              onChange={(val) => handleDataChange("urgency", val)}
            />
            <ApiDropdown
              api="Impacts"
              labelKey="name"
              valueKey="name"
              label="Impact"
              value={problem.impact}
              onChange={(val) => handleDataChange("impact", val)}
            />

            <Input
              readOnly
              type="text"
              label="Priority"
              value={problem.priority || ""}
              onChange={() => {}}
            />
          </div>
        </section>
        <section className="form-section">
          <h3>Problem Details</h3>
          <div className="grid2">
            <TextArea
              label="Summary"
              value={problem.summary || ""}
              onChange={(val) => handleDataChange("summary", val)}
              style={{
                minHeight: "30px",
                minWidth: "90%",
                backgroundColor: "white",
              }}
            />
            <TextArea
              label="Description"
              value={problem.description || ""}
              onChange={(val) => handleDataChange("description", val)}
              style={{
                minHeight: "100px",
                minWidth: "90%",
                backgroundColor: "white",
              }}
            />
            <TextArea
              label="Solution"
              value={problem.solution || ""}
              style={{
                minHeight: "100px",
                minWidth: "90%",
                backgroundColor: "white",
              }}
              onChange={(val) => handleDataChange("solution", val)}
            />
            <ApiDropdown
              api="ClosureCodes"
              labelKey="name"
              valueKey="id"
              label="Closure Code"
              value={problem.closureCode}
              onChange={(val) => handleDataChange("closureCode", val)}
            />
            <ApiDropdown
              api="Errors"
              labelKey="type"
              valueKey="id"
              label="Error Type"
              value={problem.errorType}
              onChange={(val) => handleDataChange("errorType", val)}
            />{" "}
          </div>
        </section>
        <section className="form-section">
          <h3>Responsibility</h3>
          <div className="grid">
            {/* <ApiDropdown
              api="Team"
              labelKey="name"
              valueKey="id"
              label="Responsible Team"
              value={problem.teamId}
              onChange={(val) => handleDataChange("teamId", val)}
            />
            <ApiDropdown
              api="Person"
              labelKey="name"
              valueKey="id"
              label="Responsible Person"
              value={problem.personId}
              onChange={(val) => handleDataChange("personId", val)}
            /> */}
            <Input
              readOnly
              type="text"
              label="Responsible Team"
              value={problem.responsibleTeam || ""}
              onChange={() => {}}
            />
            <Input
              readOnly
              type="text"
              label="Responsible Person"
              value={problem.responsiblePerson || ""}
              onChange={() => {}}
            />
          </div>
        </section>
        <section className="form-section">
          <h3>SLA & OLA</h3>
          <div className="grid">
            <Input
              type="text"
              label="SLA "
              readOnly
              value={problem.sla || ""}
              onChange={(val) => handleDataChange("sla", val)}
            />
            <Input
              type="text"
              label="SLA Status"
              readOnly
              value={problem.slaStatus || ""}
              onChange={(val) => handleDataChange("slaStatus", val)}
            />
          </div>
        </section>
        <section className="form-section">
          <h3>Related Object</h3>
          <div className="grid">
            <FileUploader
              value={problem.filePath}
              onRemove={(path) =>
                handleDataChange("filePath", (problem.filePath || []).filter((p: any) => p !== path))
              }
              onChange={async (files, paths) => {
                if (!files || !paths.length) return;
                const uploadedPaths: string[] = [];
                for (let i = 0; i < files.length; i++) {
                  const formData = new FormData();
                  formData.append("file", files[i]);
                  try {
                    const response = await authFetch(
                      `${config.apiBaseUrl}/api/problems/upload`,
                      {
                        method: "POST",
                        body: formData,
                      }
                    );
                    if (response.ok) {
                      const { path } = await response.json();
                      uploadedPaths.push(path);
                    } else {
                      console.error(`Upload failed for file: ${files[i].name}`);
                    }
                  } catch (error) {
                    console.error("Error uploading file", error);
                  }
                }
                if (uploadedPaths.length) {
                  handleDataChange("filePath", [
                    ...(problem.filePath || []),
                    ...uploadedPaths,
                  ]);
                }
              }}
            />

            {isAdmin && (
              <Input
                readOnly
                type="text"
                label="Related Object"
                value={problem.relatedobject || ""}
                onChange={(val) => handleDataChange("relatedobject", val)}
              />
            )}
            <>
              {isAdmin && (
                <>
                  <button type="button" onClick={handleOpenTaskLookup}>
                    Select Related Ticket
                  </button>
                  {selectedTask && selectedTask.length > 0 && (
                    <div>
                      <p>
                        <strong>Selected Tasks:</strong>
                      </p>
                      <ul>
                        {selectedTask.map((task, index) => (
                          <li key={index}>{task.ticketId}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <TaskGridLookup
                    isOpen={isTaskLookupOpen}
                    onClose={handleCloseTaskLookup}
                    onSelect={handleTaskSelect}
                    selectedItems={selectedTask}
                  />
                </>
              )}
            </>
          </div>
        </section>
        <button onClick={handleSubmit}>Submit Problem</button>
        <button type="button" onClick={handleCancel} className="cancel-btn">
          Cancel
        </button>
      </form>
    </div>
  );
}

export default ProblemEdit;
